import {MenuItemI} from '../interfaces/menu-item.i';
import {Page} from 'ionic-angular/navigation/nav-util';

export class MenuItem implements MenuItemI {
  id: number;
  icon: string;
  text: string;
  order: number;
  page: Page;
  requiresReader: boolean;
  items?: Array<MenuItem>;
  count?: number;
  requiresBadge?: boolean;

  constructor(item: MenuItemI) {
    Object.keys(item).forEach((key: string) => this[key] = item[key]);
  }

}



// WEBPACK FOOTER //
// ./src/models/MenuItem.ts